import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Stack,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { mainDataHomeText } from "../styles";
import LocalAtmIcon from "@mui/icons-material/LocalAtm";
import PersonIcon from "@mui/icons-material/Person";
import AspectRatioIcon from "@mui/icons-material/AspectRatio";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import BathtubIcon from "@mui/icons-material/Bathtub";
import { KingBed } from "@mui/icons-material";
import DonutLargeIcon from "@mui/icons-material/DonutLarge";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import FindInPageIcon from "@mui/icons-material/FindInPage";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import ModalDeleteProject from "./Modals/ModalDeleteProject";
import useApi from "../hooks/useApi";
import useSnack from "../hooks/useSnack";
import SnackAlert from "../components/SnackAlert";

const NoMaxWidthTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: "none",
  },
});

function CardOwnView({
  setPaginatedData,
  sizeXS,
  sizeMD,
  sizeLG,
  sizeSM,
  dataCard,
  types,
  editButton,
  detailsButton,
  deleteButton,
  showVerified,
}) {
  const { loadApi, loadingApi } = useApi();
  const { msgSB, openSB, showSnack, typeSB } = useSnack();
  const [modalOpen, setModalOpen] = useState(false);
  const [open, setOpen] = useState(false);
  const [projects, setProjects] = useState();

  function dateToInput(fechaOriginal) {
    if (!!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/.test(fechaOriginal)) {
      const dateObject = new Date(fechaOriginal);
      const año = dateObject.getUTCFullYear();
      const mes = (dateObject.getUTCMonth() + 1).toString().padStart(2, "0");
      const día = dateObject.getUTCDate().toString().padStart(2, "0");

      return `${año}-${mes}-${día}`;
    } else return fechaOriginal;
  }

  const formatVerified = (status) => {
    if (status === "approved") {
      return "Aprobado";
    } else if (status === "pending") {
      return "Pendiente";
    } else if (status === "rejected") {
      return "Rechazado";
    } else {
      return "Desconocido";
    }
  };

  const DeleteProject = async () => {
    await loadApi(`project/${dataCard.id}`, true, "delete")
      .then((response) => {
        showSnack(response.data.message, "success");
        setPaginatedData((prevProjects) =>
          prevProjects.filter((project) => project.id !== dataCard.id)
        );
        handleClose(false);
      })
      .catch((e) => {
        showSnack(e.message, "error");
      });
  };

  console.log(dataCard);

  // Manejar la apertura y cierre del modal
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <Grid item xs={sizeXS} sm={sizeSM} md={sizeMD} lg={sizeLG}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          borderRadius: 4,
          p: { xs: 1, md: 2 },
        }}
      >
        <Stack
          component="article"
          sx={{
            width: "100%", // Anchura fija
            height: { xs: 150, md: 150 },
            mb: 1.5,
          }}
        >
          <img
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              aspectRatio: "9/16",
              borderRadius: "8px",
            }}
            src={
              dataCard?.photo_profile[0]?.url ||
              "https://as1.ftcdn.net/v2/jpg/06/00/88/96/1000_F_600889685_N2bnfSBEyYDNW6tExn2riTS9McpnFWew.jpg"
            }
            alt="Property | Projects"
          />
        </Stack>
        <Stack
          spacing={{ xs: 0, md: 2 }}
          component="article"
          position="relative"
          sx={{ overflowX: "hidden" }}
          height="100%"
        >
          <NoMaxWidthTooltip
            disableHoverListener={dataCard?.name.length <= 20}
            title={dataCard?.name}
            arrow
          >
            <Typography
              component="h2"
              variant="h6"
              sx={{
                textTransform: "capitalize",
                display: "-webkit-box",
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
                WebkitLineClamp: 1,
                mb: 1,
                fontWeight: 700,
                fontSize: "medium",
                fontFamily: "Inter",
              }}
            >
              {dataCard?.name.length > 20
                ? dataCard?.name.slice(0, 20) + "..."
                : dataCard?.name}
            </Typography>
          </NoMaxWidthTooltip>
          {showVerified && dataCard.verified !== undefined ? (
            <Stack sx={{ mt: "8px !important" }}>
              <Typography
                component="span"
                sx={{
                  fontWeight: 700,
                  letterSpacing: ".5px",
                  fontSize: "small",
                  color:
                    dataCard?.verified === "approved"
                      ? "#0c1a00"
                      : dataCard?.verified === "pending"
                        ? "#544300"
                        : "#470000",
                  display: "block",
                  px: 2,
                  width: "fit-content",
                  borderRadius: 2,
                  backgroundColor:
                    dataCard?.verified === "approved"
                      ? "#a6ed82a8"
                      : dataCard?.verified === "pending"
                        ? "#f4e24fa8"
                        : "#ee63638c",
                }}
              >
                {formatVerified(dataCard?.verified)}
              </Typography>
            </Stack>
          ) : null}
          <Stack>
            <Typography
              component="span"
              sx={{
                marginBottom: 0.5,
                fontSize: "small",
                fontWeight: "normal",
                display: "-webkit-box",
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
                textOverflow: "ellipsis",
                WebkitLineClamp: 1, // Ajusta el número de líneas visibles aquí
              }}
            >
              {dataCard.information}
            </Typography>
          </Stack>
          <Stack
            width={{ xs: "100%", md: "100%" }}
            marginInline="auto"
            flexDirection="row"
            justifyContent="space-between"
            mb={4}
          >
            <NoMaxWidthTooltip
              title={types === "property" ? "Precio" : "Objetivo"}
              arrow
            >
              <Typography
                component="span"
                sx={{
                  ...mainDataHomeText,
                }}
              >
                <LocalAtmIcon />
                {dataCard.price
                  ? parseInt(dataCard?.price).toLocaleString("es-CO")
                  : parseInt(dataCard?.objective || 0).toLocaleString("es-CO")}
              </Typography>
            </NoMaxWidthTooltip>
            <NoMaxWidthTooltip
              title={
                types === "property" ? "Habitaciones" : "Cantidad inversores"
              }
              arrow
            >
              <Typography component="span" sx={{ ...mainDataHomeText }}>
                {types === "property" ? <KingBed /> : <PersonIcon />}
                {dataCard.bedrooms || dataCard?.cant_investors || 0}
              </Typography>
            </NoMaxWidthTooltip>
            <NoMaxWidthTooltip
              title={types === "property" ? "Temporal" : "Días restantes"}
              arrow
            >
              <Typography component="span" sx={{ ...mainDataHomeText }}>
                {types === "property" ? (
                  <AspectRatioIcon />
                ) : (
                  <CalendarTodayIcon />
                )}
                {dataCard.m2 || dataCard?.remaining_days || 0}
              </Typography>
            </NoMaxWidthTooltip>
            <NoMaxWidthTooltip
              title={types === "property" ? "Baños" : "Completado"}
              arrow
            >
              <Typography
                component="span"
                sx={{ ...mainDataHomeText, mb: { xs: 1, md: 0 } }}
              >
                {types === "property" ? <BathtubIcon /> : <DonutLargeIcon />}
                {dataCard.bathrooms || dataCard?.completed + "%"}
              </Typography>
            </NoMaxWidthTooltip>
          </Stack>
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: 1,
              justifyContent: "start",
            }}
          >
            {editButton && dataCard?.verified !== "rejected" ? (
              <Button
                size="small"
                sx={{
                  px: "0.5rem",
                  width: "fit-content",
                  color: "white",
                  backgroundColor: "primary.main",
                  borderRadius: 2,
                  "&:hover": {
                    backgroundColor: "primary.300",
                  },
                }}
                LinkComponent={Link}
                startIcon={<EditIcon fontSize="small" />}
                to={`/edit/${types}/${dataCard.id}`}
              >
                Editar
              </Button>
            ) : null}
            {detailsButton ? (
              <Button
                size="small"
                sx={{
                  px: "0.5rem",
                  width: "fit-content",
                  color: "white",
                  backgroundColor: "primary.main",
                  borderRadius: 2,
                  "&:hover": {
                    backgroundColor: "primary.300",
                  },
                }}
                LinkComponent={Link}
                startIcon={<FindInPageIcon fontSize="small" />}
                to={
                  types === "project"
                    ? `/details/project/${dataCard.id}`
                    : `/details/property/${dataCard.id}`
                }
              >
                Detalles
              </Button>
            ) : null}
            {deleteButton ? (
              <>
                <Button
                  size="small"
                  sx={{
                    px: "0.5rem",
                    width: "fit-content",
                    color: "white",
                    backgroundColor: "#d32f2f",
                    borderRadius: 2,
                    "&:hover": {
                      backgroundColor: "#da4e4e",
                    },
                  }}
                  startIcon={<DeleteIcon fontSize="small" />}
                  onClick={handleOpen}
                >
                  Eliminar
                </Button>
                <Dialog open={open} onClose={handleClose}>
                  <DialogTitle>Confirmar Eliminación</DialogTitle>
                  <DialogContent>
                    <DialogContentText>
                      ¿Estás seguro de que deseas eliminar este elemento? Esta
                      acción no se puede deshacer.
                    </DialogContentText>
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={handleClose} color="primary">
                      Cancelar
                    </Button>
                    <Button
                      onClick={() => DeleteProject()}
                      color="error"
                      autoFocus
                    >
                      Eliminar
                    </Button>
                  </DialogActions>
                </Dialog>
              </>
            ) : null}
          </Box>
        </Stack>
      </Box>
      <SnackAlert openSB={openSB} typeSB={typeSB} msgSB={msgSB} />
    </Grid>
  );
}

export default CardOwnView;
